module.exports = __webpack_public_path__ + "media/dashboard/assets/images/menu-icons/dashboard-8f77cb2bc1868384de3ee377895dc14e.svg";